import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const deletePromoCode = async (id: string) => {
  const res = await apiManager.delete(`/admin/promoCode/${id}/delete`);
  return res;
};

export const useDeletePromoCode = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await apiClient.delete(ENDPOINTS.PROMO_CODES.DELETE_PROMO_CODE(id));
      return res.data;
    },
  });
